import theme from '@styles/theme';
export default {
  container: (isStatic: boolean, isVisible: boolean, positionTop: number, keepContainerSize: boolean, highZIndex: boolean) => ({
    width: '100%',
    height: isVisible || isStatic || keepContainerSize ? 'auto' : 0,
    overflowY: isVisible || isStatic || keepContainerSize ? 'unset' : 'hidden',
    position: isStatic ? 'static' : 'fixed',
    top: isStatic ? 0 : `${positionTop}px`,
    left: 0,
    opacity: isVisible || isStatic ? 1 : 0,
    zIndex: highZIndex ? theme.zIndex.search : theme.zIndex.barMenu,
    transform: isVisible || isStatic ? 'translateY(0)' : 'translateY(-100%)',
    transition: `transform ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}, opacity ${theme.transitions.time.normal} ${theme.transitions.animation.atomCurve}`
  })
};